import { __assign } from "tslib";
import { jsxs as _jsxs, jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useState, useEffect } from "react";
import { Box, Button, Menu, Paper, Typography, Divider, } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useStoreFileViewerContext } from "../../hooks/context";
import { ObjectStore } from "../../types";
import DownloadIcon from "@mui/icons-material/Download";
import DeleteFileButton from "../DeleteFileButton";
import BulkDeleteFilesButton from "../DeleteFileButton/BulkDeleteFilesButton";
import CreateSharesButton from "../CreateNewShareButton/CreateSharesButton";
import { alertOnError } from "../AlertSnackbar/hooks";
import { downloadFile } from "../../utils/file";
var MultiSelectMenu = function (_a) {
    var _b;
    var selected = _a.selected, contextMenu = _a.contextMenu, setContextMenu = _a.setContextMenu;
    var theme = useTheme();
    var _c = useState([]), objects = _c[0], setObjects = _c[1];
    var _d = useState(false), loading = _d[0], setLoading = _d[1];
    var _e = useState(false), downloading = _e[0], setDownloading = _e[1];
    var apiRef = useStoreFileViewerContext().apiRef;
    var handleDownload = function () {
        var _a;
        if (selected.length === 1) {
            if (objects.length === 1 &&
                ((_a = objects[0]) === null || _a === void 0 ? void 0 : _a.type) !== ObjectStore.ObjectType.Folder) {
                setDownloading(true);
                return downloadFile(objects[0], apiRef)
                    .then(function () {
                    setDownloading(false);
                })
                    .catch(function (err) {
                    setDownloading(false);
                });
            }
        }
        if (!selected.length || !(apiRef === null || apiRef === void 0 ? void 0 : apiRef.getArchive))
            return;
        setDownloading(true);
        apiRef
            .getArchive({
            ids: selected,
            format: "zip",
            transfer_method: "dest-url",
        })
            .then(function (response) {
            if (response.status === "Success") {
                var location_1 = response.result.dest_url;
                if (location_1) {
                    window.open(location_1, "_blank");
                }
            }
        })
            .catch(function (err) {
            alertOnError(err);
        })
            .finally(function () {
            setDownloading(false);
        });
    };
    useEffect(function () {
        if (contextMenu !== null && selected.length === 1 && (apiRef === null || apiRef === void 0 ? void 0 : apiRef.get)) {
            setLoading(true);
            apiRef
                .get({
                id: selected[0],
            })
                .then(function (response) {
                if (response.status === "Success") {
                    setObjects([
                        __assign({}, response.result.object),
                    ]);
                }
            })
                .finally(function () {
                setLoading(false);
            });
        }
        else {
            setObjects([]);
        }
    }, [contextMenu, selected]);
    var handleDone = function () {
        setContextMenu(null);
    };
    if (!apiRef.getArchive || !selected.length)
        return null;
    return (_jsx(_Fragment, { children: _jsx(Menu, { open: contextMenu !== null, anchorReference: "anchorPosition", anchorPosition: contextMenu !== null
                ? { top: contextMenu.mouseY, left: contextMenu.mouseX }
                : undefined, onClose: function () { return setContextMenu(null); }, sx: {
                width: "350px",
            }, PaperProps: {
                sx: {
                    width: "350px",
                },
            }, children: _jsxs(Paper, { tabIndex: -1, onKeyDown: function (event) {
                    if (event.key === "Tab") {
                        event.stopPropagation();
                    }
                }, children: [_jsx(Box, { sx: { cursor: "auto", padding: 1, paddingX: 2 }, children: _jsxs(Typography, { variant: "body2", color: "textSecondary", children: [selected.length, " Selected"] }) }), selected.length === 1 ? (_jsxs(_Fragment, { children: [_jsx(Button, { variant: "text", onClick: handleDownload, disabled: downloading || loading, sx: {
                                    color: theme.palette.text.primary,
                                    width: "100%",
                                    paddingLeft: 2,
                                    justifyContent: "start",
                                }, startIcon: _jsx(DownloadIcon, { fontSize: "small" }), children: "Download" }), !!(apiRef === null || apiRef === void 0 ? void 0 : apiRef.delete) && objects.length === 1 && (_jsx(DeleteFileButton, { object: objects[0], ButtonProps: {
                                    sx: {
                                        color: theme.palette.text.primary,
                                        width: "100%",
                                        paddingLeft: 2,
                                        justifyContent: "start",
                                    },
                                }, onClose: handleDone })), !!((_b = apiRef === null || apiRef === void 0 ? void 0 : apiRef.share) === null || _b === void 0 ? void 0 : _b.create) && objects.length === 1 && (_jsxs(_Fragment, { children: [_jsx(Divider, {}), _jsx(CreateSharesButton, { ButtonProps: {
                                            sx: {
                                                color: theme.palette.text.primary,
                                                width: "100%",
                                                paddingLeft: 2,
                                                justifyContent: "start",
                                            },
                                            // @ts-ignore
                                            "data-testid": "New-Share-Btn",
                                        }, onClose: handleDone, object: objects[0], onDone: handleDone })] }))] })) : (_jsxs(_Fragment, { children: [_jsx(Button, { variant: "text", onClick: handleDownload, disabled: downloading, startIcon: _jsx(DownloadIcon, { fontSize: "small" }), sx: {
                                    color: theme.palette.text.primary,
                                    width: "100%",
                                    paddingLeft: 2,
                                    justifyContent: "start",
                                }, children: "Download ZIP" }), !!(apiRef === null || apiRef === void 0 ? void 0 : apiRef.delete) && (_jsx(BulkDeleteFilesButton, { selected: selected, ButtonProps: {
                                    sx: {
                                        color: theme.palette.text.primary,
                                        width: "100%",
                                        paddingLeft: 2,
                                        justifyContent: "start",
                                    },
                                }, onClose: handleDone }))] }))] }) }) }));
};
export default MultiSelectMenu;
